import axios from 'axios';
import {DELETE_SITE, GET_SITE, GET_SITES, POST_SITE, UPDATE_SITE} from '../routes';

export default {
    async all(options = {}) {
        return await axios.get(GET_SITES, options);
    },
    async get(site, options = {}) {
        return await axios.get(GET_SITE(site), options);
    },
    async create(data, options = {}) {
        return await axios.post(POST_SITE, data, options);
    },
    async update(site, options = {}) {
        return await axios.patch(UPDATE_SITE(site), options);
    },
    async delete(site, options = {}) {
        return await axios.delete(DELETE_SITE(site), options);
    },
};
